import type { Sibling, SiblingRole } from '../types/snak'

export const siblings: Sibling[] = [
  {
    id: 'firstborn',
    label: 'Firstborn',
    trait: 'Neat. Composed.',
    responseTitle: 'Ah, the responsible one?',
    responseBody:
      'Some say firstborns are organised, reliable and like getting things right.',
    accent: '#01332b',
    surface: '#EFF6FF',
  },
  {
    id: 'middle',
    label: 'Middle child',
    trait: 'Balanced. Easygoing.',
    responseTitle: 'Ah, the adaptable one?',
    responseBody:
      'Some say middle children are diplomatic, flexible and good at finding their place.',
    accent: '#2E7FB8',
    surface: '#F1F8FE',
  },
  {
    id: 'youngest',
    label: 'Youngest',
    trait: 'Energetic. Spontaneous.',
    responseTitle: 'Ah, the adventurous one?',
    responseBody:
      'Some say the youngest are spontaneous, social and happy to do things differently.',
    accent: '#05a63a',
    surface: '#F0FCF3',
  },
  {
    id: 'caboose',
    label: 'Caboose child',
    trait: 'Late. Warmly received.',
    responseTitle: 'Ah, the surprise arrival?',
    responseBody:
      'Some say the caboose turns up years after everyone else, gets away with everything, and quietly improves the whole family.',
    accent: '#C04E17',
    surface: '#FDF1E7',
  },
  {
    id: 'only',
    label: 'Only child',
    trait: 'Independent. Self-assured.',
    responseTitle: 'Ah, the independent one?',
    responseBody:
      'Some say only children are focused, self-reliant and know exactly what they like.',
    accent: '#0d6b57',
    surface: '#F4F1EA',
  },
]

export function getSibling(role: SiblingRole): Sibling {
  return siblings.find((s) => s.id === role) ?? siblings[0]
}
